import _ from "lodash";

import * as actions from "./actions";
import {
  getNextPage,
  sendSearchRequest,
  getTrackById,
  sendSearchForMiscRequest,
  getTracksForCollection,
} from "../../../api/spotify.api";

const validateQueryString = (string) => {
  return _.isString(string) && string.length > 1;
};

export const editSearchString = (string) => {
  return { type: actions.EDIT_SEARCH_STRING, string };
};

export const sendGetTrackRequest = (id) => {
  console.log("sendGetTrackRequest");
  console.log(id);
  return async (dispatch) => {
    dispatch({ type: actions.START_SEARCH_REQUEST });
    dispatch({ type: actions.EMPTY_SEARCH_RESULTS });
    const { ok, data } = await getTrackById(id);
    console.log(data);
    if (ok) {
      dispatch({ type: actions.LOAD_SINGLE_TRACK, payload: data });
    }
    dispatch({ type: actions.END_SEARCH_REQUEST });
  };
};

export const handleSearchResults = ({ ok, data, error }) => {
  return (dispatch) => {
    if (ok) {
      dispatch({
        payload: data,
        type: actions.LOAD_SEARCH_RESULTS,
      });
    } else {
      console.warn("Cannot handle error");
      console.warn(error.stack);
    }
    dispatch({ type: actions.END_SEARCH_REQUEST });
  };
};
export const handleCollectionResults = ({ ok, data, error }) => {
  return (dispatch) => {
    if (ok) {
      dispatch({
        payload: data,
        type: actions.LOAD_COLLECTION_RESULTS,
      });
    } else {
      console.warn("Cannot handle error");
      console.warn(error.stack);
    }
    dispatch({ type: actions.END_COLLECTION_REQUEST });
  };
};

export const handleMiscSearchResults = ({ ok, data, error }) => {
  return (dispatch) => {
    if (ok) {
      dispatch({ payload: data, type: actions.LOAD_MISC_SEARCH_RESULTS });
    } else {
      console.warn("Cannot handle error");
      console.warn(error.stack);
    }
    dispatch({ type: actions.END_SEARCH_REQUEST });
  };
};

export const dispatchNextPageRequest = () => {
  return async (dispatch, getState) => {
    const nextPageToken = getState().search.nextPageToken;
    dispatch({ type: actions.START_SEARCH_REQUEST });
    dispatch(handleSearchResults(await getNextPage(nextPageToken)));
  };
};

export const dispatchSearchRequest = () => {
  return async (dispatch, getState) => {
    const queryString = getState().search.searchString;
    if (!validateQueryString(queryString)) {
      return dispatch({ type: actions.INVALID_QUERY_STRING });
    }
    dispatch({ type: actions.START_SEARCH_REQUEST });
    dispatch({ type: actions.EMPTY_SEARCH_RESULTS });
    dispatch(
      handleMiscSearchResults(
        await sendSearchForMiscRequest({
          query: queryString,
          country: getState().preferences.locale,
        }),
      ),
    );
    dispatch(
      handleSearchResults(
        await sendSearchRequest({
          query: queryString,
          country: getState().preferences.locale,
        }),
      ),
    );
  };
};

export const dispatchCollectionRequest = (item) => {
  return async (dispatch, getState) => {
    dispatch({ type: actions.START_COLLECTION_REQUEST });
    dispatch(
      handleCollectionResults(
        await getTracksForCollection({
          ...item,
          country: getState().preferences.locale,
        }),
      ),
    );
  };
};
